
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 96 96"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.358.004C20.85.357-.351 22.133.004 48.641c.354 26.507 22.129 47.71 48.637 47.354 26.506-.354 47.71-22.129 47.354-48.638C95.642 20.85 73.862-.352 47.358.004zm1.148 85.888c-20.928.279-38.119-16.459-38.398-37.388-.279-20.926 16.459-38.117 37.385-38.397C68.42 9.828 85.61 26.564 85.891 47.492c.279 20.929-16.459 38.118-37.385 38.4zm-12.252-29.76c-2.027 0-3.562-.738-4.602-2.219-1.041-1.479-1.559-3.45-1.559-5.915 0-5.42 2.053-8.131 6.16-8.131.82 0 1.711.273 2.668.82.957.549 1.766 1.508 2.424 2.875l6.16-3.203c-2.463-4.436-6.545-6.654-12.24-6.654-3.889 0-7.104 1.287-9.648 3.861-2.547 2.574-3.822 6.051-3.822 10.432 0 4.491 1.262 7.997 3.779 10.517s5.834 3.777 9.941 3.777c2.572 0 4.928-.645 7.062-1.93 2.135-1.287 3.807-3.053 5.012-5.299l-5.67-2.876c-1.094 2.63-2.983 3.945-5.665 3.945zm26.532 0c-2.027 0-3.561-.738-4.6-2.219-1.041-1.479-1.561-3.45-1.561-5.915 0-5.42 2.053-8.131 6.16-8.131.875 0 1.793.273 2.75.82.959.549 1.768 1.508 2.426 2.875l6.076-3.203c-2.41-4.436-6.461-6.654-12.156-6.654-3.889 0-7.105 1.287-9.652 3.861-2.545 2.574-3.816 6.051-3.816 10.432 0 4.491 1.244 7.997 3.736 10.517 2.49 2.52 5.818 3.777 9.98 3.777 2.518 0 4.846-.645 6.98-1.93 2.135-1.287 3.832-3.053 5.094-5.299l-5.75-2.876c-1.095 2.63-2.986 3.945-5.667 3.945z","fill":"#030104"}})])
          )
        }
      }
    